module.exports = __webpack_public_path__ + "img/丹参.37393ca4.jpg";